import React from 'react';
import { classNames } from '@pwskills/rachnaui/utils';
import { IIcon } from '../Icons.types';

const Lock = (props: IIcon) => {
  const { className = '', fill, ...rest } = props;

  return (
    <svg
      {...rest}
      className={classNames('w-5 h-5', className)}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 9.68042H4.16667C3.24619 9.68042 2.5 10.4266 2.5 11.3471V17.1804C2.5 18.1009 3.24619 18.8471 4.16667 18.8471H15.8333C16.7538 18.8471 17.5 18.1009 17.5 17.1804V11.3471C17.5 10.4266 16.7538 9.68042 15.8333 9.68042Z"
        fill={fill || '#989DA5'}
      />
      <path
        d="M5.83594 9.68066V6.34733C5.83594 5.24226 6.27492 4.18245 7.05633 3.40105C7.83773 2.61965 8.89754 2.18066 10.0026 2.18066C11.1077 2.18066 12.1675 2.61965 12.9489 3.40105C13.7303 4.18245 14.1693 5.24226 14.1693 6.34733V9.68066"
        stroke={fill || '#989DA5'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Lock;
